<script lang="ts">
  import type { Snippet } from 'svelte';
  import type { HTMLButtonAttributes } from 'svelte/elements';

  interface Props extends HTMLButtonAttributes {
    variant?: 'primary' | 'ghost' | 'danger' | 'confirmDanger';
    size?: 'md' | 'sm';
    children: Snippet;
  }

  let { variant = 'ghost', size = 'md', type = 'button', children, ...rest }: Props = $props();
</script>

<button class="button {variant} {size}" {type} {...rest}>
  {@render children()}
</button>

<style>
  .button {
    display: inline-flex;
    align-items: center;
    gap: var(--space-2);
    border: 1px solid var(--border-strong);
    border-radius: var(--radius-md);
    font-size: 13px;
    color: var(--text-secondary);
    transition: all var(--duration-fast) var(--easing-default);
  }
  .md {
    padding: var(--space-2) var(--space-4);
  }
  .sm {
    font-size: 12px;
    padding: var(--space-1) var(--space-3);
    border-radius: var(--radius-sm);
  }
  .ghost:hover:not(:disabled, [aria-disabled='true']) {
    background: var(--bg-hover);
    color: var(--text-primary);
  }
  .primary {
    background: var(--accent-bg);
    color: var(--accent);
    border-color: var(--border-accent);
    font-weight: 500;
  }
  .primary:hover:not(:disabled) {
    background: var(--accent);
    color: white;
    border-color: var(--accent);
  }
  .danger:hover:not(:disabled) {
    color: var(--color-danger);
    border-color: var(--color-danger-border);
    background: var(--color-danger-bg);
  }
  .confirmDanger {
    color: var(--color-danger);
    border-color: var(--color-danger-border);
    background: var(--color-danger-bg);
    font-weight: 500;
  }
  .button:disabled,
  .button[aria-disabled='true'] {
    opacity: 0.5;
    cursor: not-allowed;
  }
</style>
